export const UserRegister = {
	// Step 1
	'Enrollment Form': 'Formulario de Inscripción',
	'Already registered? Sign in!': '¿Ya estás registrado? ¡Inicia sesión!',
	'Register now': 'Regístrate',
	// Step 1
	'The registration form is temporarily disabled.':
		'El formulario de registro está deshabilitado temporalmente.',
	// Step 2
	'Verify your identity': 'Verifica tu identidad',
	Step2: {
		title: 'Verifica tu identidad',
		description: 'No pudimos cargar los pasos de validación de identidad.',
		noOrientations:
			'No hay pasos de validación disponibles en este momento. Por favor, contacta a soporte.',
	},
	'Back to home': 'Volver al inicio',
	'Go to login': 'Ir al login',
	// Verificación de identidad (Truora)
	'Exit the verification process?': '¿Salir del proceso de verificación?',
	'If you go back you will have to start the validation again.':
		'Si vuelves atrás deberás iniciar nuevamente la validación.',
	'Yes, go back': 'Sí, volver',
	'Continue verification': 'Continuar verificación',
	'Error getting the verification link:':
		'Error al obtener el enlace de verificación:',
	'Unknown error': 'Error desconocido',
	'Loading verification link...': 'Cargando enlace de verificación...',
	Back: 'Volver',
	// Step 2 (Biomatch)
	'Identity validation service temporarily unavailable, contact support or try again later.':
		'Servicio de validación de identidad temporalmente no disponible, contáctate con soporte o inténtalo más tarde.',
};
